'use strict';

import {
  classes,
  addClassToElement,
  removeClassToElement
} from '@jspartials/class-list-utils';
import { body } from '@jspartials/general-utils';

// Selectors
const selector = {
  hellobar: `.js-hellobar`,
  hellobarMessagesWrapper: `.js-hellobar__messages-wrapper`,
  hellobarMessage: `.js-hellobar__message`
};

// Elements
const element = {
  hellobar: document.querySelector(selector.hellobar) || null,
  hellobarMessagesWrapper:
    document.querySelector(selector.hellobarMessagesWrapper) || null
};

// Variables
const timeToResetMessage = 600;
const defaultTimeBetweenMessages = 5000;
const timeBetweenMessages = element.hellobar
  ? element.hellobar.dataset.timeBetweenMessages
  : defaultTimeBetweenMessages;
let animationBetweenMessages = null;
let totalMessages = 0;
let count = 0;

// Functions

const animate = () => {
  animateOut();
  animateIn();

  setTimeout(() => {
    const bothClasses = document.querySelector(
      `${selector.hellobarMessage}.${classes.is.animatedIn}.${classes.is.animatedOut}`
    );
    removeClassToElement(
      bothClasses,
      classes.is.animatedIn,
      classes.is.animatedOut
    );
  }, timeToResetMessage);
};

const getIndexNextElement = () => {
  const nextIndex = count + 1;

  return nextIndex < totalMessages ? nextIndex : 0;
};

const getMessageByIndex = (index) => {
  return document.querySelector(
    `${selector.hellobarMessage}[data-index="${index}"]`
  );
};

const animateIn = () => {
  const indexNextElement = getIndexNextElement();
  const nextElement = getMessageByIndex(indexNextElement);

  addClassToElement(nextElement, classes.is.animatedIn);
};

const animateOut = () => {
  const actualElement = getMessageByIndex(count);

  addClassToElement(actualElement, classes.is.animatedOut);
};

const setHellobarMessages = () => {
  const hellobarMessages =
    document.querySelectorAll(selector.hellobarMessage) || [];

  hellobarMessages.forEach((hellobarMessage, index) => {
    hellobarMessage.dataset.index = index;

    if (index === 0) {
      addClassToElement(hellobarMessage, classes.is.animatedIn);
    }

    totalMessages++;
  });
};

const initHelloBar = () => {
  const animationType = element.hellobar.dataset.animationType;

  if (animationType === 'slide') {
    setHellobarMessages();

    if (totalMessages > 1) {
      animationBetweenMessages = setInterval(() => {
        animate();
        count = getIndexNextElement();
      }, timeBetweenMessages);
    } else {
      if (animationBetweenMessages) {
        clearInterval(animationBetweenMessages);
      }
    }
  } else if (animationType === 'marquee') {
    const wrappers = [element.hellobarMessagesWrapper];
    const numberOfClones = 1;

    for (let i = 0; i < numberOfClones; i++) {
      const clone = element.hellobarMessagesWrapper.cloneNode(true);
      element.hellobar.appendChild(clone);
      wrappers.push(clone);
    }

    wrappers.forEach((wrapper) => {
      addClassToElement(wrapper, classes.is.animated);
    });

    setDynamicMarqueeSpeed();

    window.addEventListener('resize', setDynamicMarqueeSpeed);
  }
};

const setDynamicMarqueeSpeed = () => {
  const wrappers = document.querySelectorAll(selector.hellobarMessagesWrapper);

  if (!wrappers.length) return;

  wrappers.forEach((wrapper) => {
    const width = wrapper.scrollWidth;
    const viewport = window.innerWidth;
    const baseSpeed = 100;

    const distance = width + viewport;
    const duration = distance / baseSpeed;

    wrapper.style.animationDuration = `${duration}s`;
  });
};

document.addEventListener('DOMContentLoaded', function () {
  if (element.hellobar) {
    initHelloBar();
  } else {
    removeClassToElement(body, classes.has.hellobar);
  }
});
